import React, { useContext } from 'react'
import { Container, Button } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import { ThemeContext } from '../../../layouts/ThemeProvider'

import IntroImage1_default from '../../../../assets/img/landing/intro-1.png'
import IntroImage2_default from '../../../../assets/img/landing/intro-3.png'
import IntroImage3_default from '../../../../assets/img/landing/intro-2.png'

import IntroImage1_dark from '../../../../assets/img/landing/intro-1--dark.png'
import IntroImage2_dark from '../../../../assets/img/landing/intro-3--dark.png'
import IntroImage3_dark from '../../../../assets/img/landing/intro-2--dark.png'

const IntroSection = ({
    title = "Powerful and dynamic platform for soccer professionals",
    description = "Qui qui ad dolor commodo non occaecat fugiat eu. Incididunt eu ullamco labore Lorem enim non aliqua. Id et ipsum labore commodo pariatur proident excepteur et."
}) => {
    const theme = useContext(ThemeContext);

    return (
        <div className="intro-section">
            <Container fluid>
                <div className="info-container">
                    <h1 className="title">{title}</h1>
                    <p className="text">{description}</p>
                    <div className="actions">
                        <Button
                            variant="primary"
                            className="lg"
                            as={NavLink}
                            to="/signup"
                        >Register Now</Button>
                        <Button
                            variant="secondary"
                            className="lg"
                            as={NavLink}
                            to="/signin"
                        >Login</Button>
                    </div>
                </div>
                <div className="images-container">
                    <img className="left" src={theme === 'dark' ? IntroImage1_dark : IntroImage1_default} alt="Player Full Profile-Video and Analysis" />
                    <img className="center" src={theme === 'dark' ? IntroImage2_dark : IntroImage2_default} alt="Player Search - Player Details" />
                    <img className="right" src={theme === 'dark' ? IntroImage3_dark : IntroImage3_default} alt="Player Search - Filters-Season" />
                </div>
            </Container>
        </div>
    )
}

export default IntroSection
